import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from '@src/app/modules/address/address.service';
import { CommonService } from '@src/app/services/common.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { AllPeopleYouMayKnowComponent } from '@src/app/standalone-components/all-people-you-may-know/all-people-you-may-know.component';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { UserCardComponent } from '../user-card/user-card.component';

@Component({
    selector: 'app-people-you-may-know',
    standalone: true,
    imports: [CommonModule, SharedModule, NzSkeletonModule, UserCardComponent, AllPeopleYouMayKnowComponent],
    templateUrl: './people-you-may-know.component.html',
    styleUrls: ['./people-you-may-know.component.less'],
})
export class PeopleYouMayKnowComponent implements OnInit {
    @Input() walletAddress: string;

    realWalletAddress: string;

    fetching = false;

    peopleYouMayKnow: any[];

    constructor(private addressService: AddressService, public walletStatusService: WalletStatusService, public commonService: CommonService) {}

    ngOnInit() {
        this.realWalletAddress = this.walletAddress || this.walletStatusService.walletAddress;

        this.fetching = true;
        this.addressService
            .getAlsoViewed(this.realWalletAddress)
            .then(data => {
                this.peopleYouMayKnow = data.slice(0, 3);
                this.commonService.setAddressIconMap(data.map(item => item.wallet_address));
            })
            .finally(() => (this.fetching = false));
    }
}
